import { useState } from 'react';
import { Modal } from 'antd';
import { notify } from 'src/utils/notification';
import { resetPassword } from 'src/api/forgot-password';
import { APP_CODE, ERROR_MESSAGES, SUCCESS_CODE } from 'src/shared/constants';
import { ERROR_CODE } from 'src/shared/enum/errors_code.enum';

interface IUseResetPasswordStepProps {
  username: string;
  otpToken: string;
  onSuccess: () => void;
  onSessionExpired?: () => void;
}

export const useResetPasswordStep = ({
  username,
  otpToken,
  onSuccess,
  onSessionExpired,
}: IUseResetPasswordStepProps) => {
  const [loading, setLoading] = useState(false);

  const handleResetPassword = async (newPassword: string, isValid: boolean) => {
    if (!isValid) {
      notify.error('Mật khẩu không đáp ứng yêu cầu');
      return;
    }

    if (!otpToken) {
      notify.error('Token xác thực không hợp lệ');
      return;
    }

    setLoading(true);
    try {
      const res = await resetPassword({
        username,
        appCode: APP_CODE,
        newPassword,
        otpToken,
      });

      if (res?.code === SUCCESS_CODE) {
        notify.success('Đặt lại mật khẩu thành công');
        onSuccess();
      } else {
        notify.error(res?.message || 'Có lỗi xảy ra');
      }
    } catch (error: any) {
      console.error('Reset password error:', error);

      const errorCode = error?.response?.data?.code;

      if (errorCode === ERROR_CODE.E217_AUTH) {
        Modal.error({
          title: 'Phiên làm việc hết hạn',
          content:
            'Phiên xác thực của bạn đã hết hạn sau 10 phút. Vui lòng xác thực lại để tiếp tục đặt mật khẩu mới.',
          okText: 'Đóng',
          centered: true,
          onOk: () => {
            if (onSessionExpired) {
              onSessionExpired();
            }
          },
        });
        return;
      }

      if (!error?.response?.data?.code) {
        notify.error(ERROR_MESSAGES.DEFAULT);
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    handleResetPassword,
  };
};
